/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import ApplicationState from 'g3w-state'
  import G3wInput         from 'components/InputG3W.vue';
  import Fields           from 'components/g3w-fields';

  const __vue_script__ = {
    name: "node",
    props: [
      'contenttype',
      'node',
      'fields',
      'showTitle',
      'addToValidate',
      'removeToValidate',
      'changeInput',
      'layerid',
      'feature',
      'showRelationByField',
      'handleRelation'
    ],
    components: {
      G3wInput,
      ...Fields
    },
    data() {
      return {
        context:          this.contenttype,
        editing_required: false
      }
    },
    computed: {
      /**
       *
       * @returns {*|*[]}
       */
      filterNodes() {
        const filterNodes = this.node?.nodes?.filter(node => {
          if ('group' === this.getNodeType(node) ) { return true }
          else if (!node.nodes && node.name && 'group' != this.getNodeType(node)) {
            node.relation = true;
            return true;
          } else {
            return !!this.fields.find(f => node.field_name === (f.name || node.relation));
          }
        });
        return filterNodes || [];
      },
      /**
       *
       * @returns {number}
       */
      nodesLength() {
        return this.filterNodes.length;
      },
      /**
       *
       * @returns {number}
       */
      rows() {
        let rowCount = 1;
        if (0 === this.nodesLength ) {
          rowCount = 0;
        } else if (this.columnNumber <= this.nodesLength) {
          rowCount = Math.floor(this.nodesLength / this.columnNumber) + (this.nodesLength % this.columnNumber);
        }
        return rowCount;
      },
      /**
       *
       * @returns {number|number|number}
       */
      columnNumber() {
        const columnCount = parseInt(this.node.columncount) ? parseInt(this.node.columncount): 1;
        return columnCount > this.nodesLength ? this.nodesLength:  columnCount;
      },
      /**
       *
       * @returns {*}
       */
      showGroupTile() {
        return this.showTitle && this.node.showlabel && this.node.groupbox;
      }
    },
    methods: {
      /**
       *
       * @param relation
       * @returns {*|{loading: boolean}}
       */
      loadingRelation(relation) {
        // FIXME: prevent a fatal error when creating a relation Tab (even if the project has no relations)
        return (ApplicationState.project.getLayerById(this.layerid)?.getRelationById(relation.name) || { state: { loading: false } }).state;
      },
      /**
       *
       * @param relation
       * @returns {boolean|false|*}
       */
      isRelationDisabled(relation) {
        return undefined === this.getRelationName(relation.name) ||
          ('editing' === this.contenttype  && this.isRelationChildLayerNotEditable(relation));
        //return this.getRelationName(relation.name) === undefined || (this.contenttype === 'editing' && (relation.nmRelationId || this.isRelationChildLayerNotEditable(relation.name)));
      },
      /**
       *
       * @param relationId
       * @returns {*}
       */
      getRelationName(relationId) {
        return (ApplicationState.project.getRelationById(relationId) || {}).name;
      },
      /**
       *
       * @param relation
       * @returns {boolean}
       */
      isRelationChildLayerNotEditable(relation) {
        // HANDLE N:M RELATION AS 1:N RELATION
        const projectRelation = ApplicationState.project.getRelationById(relation.name);
        const relationLayer   = ApplicationState.project.getLayerById(projectRelation.referencingLayer);
        // check if is editable. In the case of nmRelation layer need to be table to be editable
        //Need to check if layer exists. Sometime can happen that layer is not in the list based on user capabilities
        return !(relationLayer && relationLayer.isEditable());
      },
      /**
       *
       * @param row
       * @returns {T[]}
       */
      getNodes(row) {
        const startIndex = (row - 1) * this.columnNumber;
        return this.filterNodes.slice(startIndex, this.columnNumber + startIndex);
      },
      /**
       *
       * @param row
       * @param column
       * @returns {T}
       */
      getNode(row, column) {
        return this.getNodes(row)[column - 1];
      },
      /**
       *
       * @param node
       * @returns {{relation}|*}
       */
      getField(node) {
        if (node.relation) { return node }
        //get field of layer
        const field = this.fields.find(f => node.field_name === f.name);
        //set showlabel
        field.showlabel = node.showlabel;
        return field;
      },
      /**
       *
       * @param node
       * @returns {string}
       */
      getNodeType(node) {
        const type = (node.groupbox || node.nodes) ?
          'group' :
          node.relation ? 'relation': 'field';
        if ('field' === type && [undefined, ''].includes(node.alias)) {
          node.alias = node.field_name;
        }
        return type;
      },
      getComponent(field) {
        if (field.relation) { return }
        else if (field.query) { return field.input.type }
        else { return 'g3w-input' }
      }
    }
  }

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-node group"},[(_vm.showGroupTile)?_c('h5',{staticClass:"title group-title",class:{'mobile': _vm.isMobile()},style:({fontSize: _vm.isMobile() ? '1em' : '1.1em'})},[_vm._v(_vm._s(_vm.node.name)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.rows),function(row){return _c('div',{staticClass:"node-row",class:{'mobile': _vm.isMobile()}},[_vm._l((_vm.columnNumber),function(column){return [(_vm.getNode(row, column))?[('field' === _vm.getNodeType(_vm.getNode(row, column)))?_c(_vm.getComponent(_vm.getField(_vm.getNode(row, column))),{tag:"component",staticStyle:{"padding":"5px 3px 5px 3px"},attrs:{"state":_vm.getField(_vm.getNode(row, column)),"changeInput":_vm.changeInput,"addToValidate":_vm.addToValidate,"removeToValidate":_vm.removeToValidate,"feature":_vm.feature},on:{"changeinput":_vm.changeInput,"addinput":_vm.addToValidate,"removeinput":_vm.removeToValidate}}):[('group' === _vm.getNodeType(_vm.getNode(row, column)))?_c('tabs',_vm._b({staticClass:"sub-group",staticStyle:{"width":"100% !important"},attrs:{"group":true,"tabs":[_vm.getNode(row, column)]}},'tabs',_vm.$props,false)):[(_vm.showRelationByField)?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.isRelationDisabled(_vm.getNode(row, column)) || _vm.loadingRelation(_vm.getNode(row, column)).loading),expression:"isRelationDisabled(getNode(row, column)) || loadingRelation(getNode(row, column)).loading"}],style:({cursor: _vm.showRelationByField && 'pointer'}),on:{"click":function($event){$event.stopPropagation();_vm.handleRelation({ relation: _vm.getNode(row, column), feature:_vm.feature, layerId: _vm.layerid })}}},[_c('bar-loader',{attrs:{"loading":_vm.loadingRelation(_vm.getNode(row, column)).loading}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('div',{staticClass:"query_relation_field"},[_c('i',{class:_vm.g3wtemplate.font[("" + (_vm.context === 'query' ? 'relation' : 'pencil'))]})]),_vm._v(" "),_c('span',{staticClass:"query_relation_field_message g3w-long-text"},[_c('span',{staticStyle:{"text-transform":"uppercase"}},[_vm._v(" "+_vm._s(_vm.getRelationName(_vm.getNode(row, column).name)))])])])],1):_vm._e()]]]:_vm._e()]})],2)})],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-33d96cc8_0", { source: ".tab-node[data-v-33d96cc8]{min-width:0;overflow:hidden}.tab-node.odd[data-v-33d96cc8]{background-color:hsl(from var(--skin-color) h s l / .1)}.title[data-v-33d96cc8]{font-weight:700;width:100%;color:#fff;padding:3px;margin-top:5px;margin-bottom:5px;border-radius:2px}.node-row[data-v-33d96cc8]{margin-bottom:0;column-gap:2px;margin-top:0;display:grid;grid-auto-columns:minmax(0,1fr);grid-auto-flow:column}.row.mobile[data-v-33d96cc8]{margin-bottom:0!important}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-33d96cc8"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "GlobalTabsNode.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__